
(()=>{
  const drawer=document.querySelector('#cart-drawer');
  const scroll=drawer?.querySelector('.lumy-cart-scroll');
  const bottom=scroll?.querySelector('.cart-bottom');
  if(!drawer||!scroll||!bottom)return;
  drawer.append(bottom);
  const style=document.createElement('style');
  style.id='lumy-cart-pinned-checkout';
  style.textContent='#cart-drawer{display:flex;flex-direction:column;height:100dvh;max-height:100dvh;overflow:hidden}#cart-drawer .lumy-cart-scroll{flex:1 1 auto;min-height:0;overflow-y:auto;overscroll-behavior:contain}#cart-drawer>.cart-bottom{position:relative;bottom:auto;flex:0 0 auto;z-index:5;background:#121b28;box-shadow:0 -8px 18px #07101d88}';
  document.head.append(style);
})();

(()=>{
 const freeVariants=new Set([]);
 const physicalItems=cart=>(cart?.items||[]).filter(item=>item.requires_shipping!==false);
 window.LUMY_SHIPPING_IS_FREE=(cart,country)=>/^[A-Z]{2}$/.test(country)&&physicalItems(cart).length>0&&physicalItems(cart).every(item=>freeVariants.has(String(item.variant_id)));
 let latestCart=null,rateKey='',rateFree=null,requestVersion=0,rateTimeout;
 let destination=window.LUMY_SHIPPING_COUNTRY||{code:'',name:''};
 const root=window.Shopify?.routes?.root||'/';
 function paintShipping(cart){
  const box=document.querySelector('#cart-shipping'),message=document.querySelector('#cart-shipping-message'),progress=document.querySelector('#cart-shipping-progress');
  if(!box||!message||!progress)return;
  box.hidden=!(cart?.items?.length);
  const physical=physicalItems(cart),free=rateFree===null?window.LUMY_SHIPPING_IS_FREE(cart,destination.code):rateFree;
  message.textContent=!physical.length?'No shipping required':free?'You unlocked FREE shipping 🎉 🚚':'Shipping calculated at checkout';
  progress.style.width=free?'100%':'0%';
  if(progress.parentElement)progress.parentElement.hidden=!free;
 }
 async function requestRates(cart,version){
  if(!destination.name||!physicalItems(cart).length)return;
  const address=cart.shipping_address||{},params=new URLSearchParams();
  params.set('shipping_address[country]',address.country||destination.name);
  if(address.zip)params.set('shipping_address[zip]',address.zip);
  if(address.province)params.set('shipping_address[province]',address.province);
  try{
   const prepared=await fetch(root+'cart/prepare_shipping_rates.json?'+params,{method:'POST',credentials:'same-origin'});
   if(!prepared.ok||version!==requestVersion)return;
   for(let attempt=0;attempt<4;attempt++){
    const response=await fetch(root+'cart/async_shipping_rates.json?'+params,{credentials:'same-origin'});
    if(!response.ok||version!==requestVersion)return;
    const data=await response.json();
    if(data?.shipping_rates?.length){
     rateFree=data.shipping_rates.some(rate=>Number.isFinite(Number(rate.price))&&Number(rate.price)===0);
     if(latestCart)paintShipping(latestCart);
     return;
    }
    if(data!==null)return; // Empty or incomplete address: retain verified profile fallback.
    await new Promise(resolve=>setTimeout(resolve,400));
   }
  }catch{/* Retain verified unconditional profile, or conservative checkout message. */}
 }
 window.LUMY_ESTIMATE_CART_SHIPPING=cart=>{
  latestCart=cart;
  const nextKey=JSON.stringify([destination,cart.items.map(item=>[item.key,item.quantity,item.requires_shipping]),cart.total_price,cart.shipping_address]);
  if(nextKey!==rateKey){
   rateKey=nextKey;rateFree=null;requestVersion++;clearTimeout(rateTimeout);
   const version=requestVersion;rateTimeout=setTimeout(()=>requestRates(cart,version),180);
  }
  paintShipping(cart);
 };
 // Localized country is the shopper's selected market; do not overwrite a selection with IP geolocation.
 if(!destination.code){
  fetch(root+'browsing_context_suggestions.json?country[enabled]=true',{credentials:'same-origin'}).then(response=>response.ok?response.json():null).then(data=>{
   const country=data?.detected_values?.country;
   if(!country)return;destination={code:String(country.handle||'').toUpperCase(),name:country.name||''};
   if(latestCart)window.LUMY_ESTIMATE_CART_SHIPPING(latestCart);
  }).catch(()=>{});
 }
 let cartCount=0;
 window.LUMY_RENDER_CART_OFFER=(state,count)=>{
  if(count!==undefined)cartCount=count;
  const bar=document.querySelector('#cart-reserve');if(!bar)return;
  bar.hidden=!cartCount||!state;
  if(!state)return;
  const seconds=state.active?Math.max(0,state.seconds):0;
  document.querySelector('#cart-reserve-label').textContent=!state.active?'Offer window ended':state.returnActive?'✨ Save 20% + extra '+state.extra:'✨ Your 20% off ends in';
  document.querySelector('#cart-offer-minutes').textContent=String(Math.floor(seconds/60)).padStart(2,'0');
  document.querySelector('#cart-offer-seconds').textContent=String(seconds%60).padStart(2,'0');
  bar.classList.toggle('cart-offer-return',!!state.returnActive);
  bar.classList.toggle('cart-reserve-ended',!state.active);
  bar.style.setProperty('--cart-reserve-progress',Math.min(100,Math.max(0,100-seconds*100000/state.duration))+'%');
 };
})();
